import React from 'react';
interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  index: number;
}
export function FeatureCard({
  icon,
  title,
  description
}: FeatureCardProps) {
  return <div data-component="COMP-10-FeatureCard" className="bg-white p-8 rounded-2xl border border-navy-50 shadow-sm" data-id="element-138">
      <div className="w-14 h-14 rounded-xl bg-navy-50 text-gold-500 flex items-center justify-center mb-6" data-id="element-139">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-140">{title}</h3>
      <p className="text-navy-600 leading-relaxed" data-id="element-141">{description}</p>
    </div>;
}